import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  mainWrapper: {
    minHeight: '80vh',
  },
}));
